import styled from "styled-components";

export const SuggestionsText = styled.div`
    margin-top: 50px;
    margin-bottom: 20px;
`;